const SYRVE_TO_KITCHEN_STATUS = {
    'Confirmed': 'inKitchen',
    'CookingStarted': 'beingPrepared',
    'CookingCompleted': 'ready',
    'OnWay': 'onTheWay',
    'Delivered': 'completed',
    'Closed': 'completed',
};

const KITCHEN_STATUS_PRIORITY = {
    'inKitchen': 1,
    'beingPrepared': 2,
    'ready': 3,
    'onTheWay': 4,
    'completed': 5,
};

export function getKitchenStatus(order) {
    if (order.status === 'completed') return 'completed';
    if (order.status === 'failed') return 'failed';
    if (order.status === 'declined') return 'failed';

    const syrveStatuses = order.syrveStatuses;
    if (!syrveStatuses || Object.keys(syrveStatuses).length === 0) {
        return order.status;
    }

    let lowestPriority = Infinity;
    let lowestStatus = null;

    for (const [, syrveStatus] of Object.entries(syrveStatuses)) {
        const kitchenStatus = SYRVE_TO_KITCHEN_STATUS[syrveStatus];
        if (kitchenStatus && KITCHEN_STATUS_PRIORITY[kitchenStatus] < lowestPriority) {
            lowestPriority = KITCHEN_STATUS_PRIORITY[kitchenStatus];
            lowestStatus = kitchenStatus;
        }
    }

    return lowestStatus || order.status;
}

export function getKitchenStatusStep(kitchenStatus) {
    if (kitchenStatus === 'inKitchen') return 1;
    if (kitchenStatus === 'beingPrepared') return 2;
    if (kitchenStatus === 'ready' || kitchenStatus === 'onTheWay' || kitchenStatus === 'completed') return 3;
    return 0;
}
